import { defineStore } from 'pinia'
import { ref } from 'vue'
import { getSellerName } from '@/services/SellerService'

export const useSellerStore = defineStore('seller', () => {
  const seller = ref("")

  async function initialize() {
    const name = await getSellerName()
    seller.value = name
  }

  return {
    seller,
    initialize,
  }
})